<template>
    <div>
        <div class="p-4">
            <div class="flex">
                <div class="flex items-center mb-3">
                    <InputGroup label="Email/IC/Name" v-model="search" class="mr-3" />
                    <!-- <InputGroup label="Email" v-model="email" class="mr-3" />
                    <InputGroup label="IC" v-model="icNumber" class="mr-3" />
                    <InputGroup label="Name" v-model="name" class="mr-3" /> -->
                    <SelectGroup label="Status" v-model="status" :options="{all: 'All', ...getUserStatuses()}" class="mr-3" />
                    <SelectGroup label="Event" v-model="selectedEvent" :options="{all: 'All', ...events}" class="mr-3" />
                    <span class="flex mr-3 items-center" v-if="selectedEvent !== 'all'">
                        <input name="event" type="radio" id="exhibitor" v-model="selectedEventRole" value="exhibitor" class="mr-2 text-secondary focus:ring-secondary" />
                        <label class="mr-2" for="exhibitor">Exhibitor</label>
                        <input name="event" type="radio" id="visitor" v-model="selectedEventRole" value="visitor" class="mr-2 text-secondary focus:ring-secondary" />
                        <label for="visitor">Visitor</label>
                    </span>
                    <ButtonSecondary @click="filterItem" class="mr-3">Filter</ButtonSecondary>
                </div>
            </div>
            <div class="flex justify-end">
                Num of Records: {{ numOfRecords }}
            </div>
            <div class="relative overflow-x-auto rounded-xl border-2">
                <table class="w-full text-sm text-left text-gray-500 shadow-lg">
                    <thead class="text-xs text-gray-700 bg-primary">
                        <tr>
                            <th scope="col" class="px-6 py-3 select-none text-white" :class="sortable[index] ? 'cursor-pointer' : ''" v-for="(header, index) in headers" :key="header" @click="sortable[index] ? sortItem(fields[index]) : null">
                                <span class="inline-block text-sm font-bold">{{ header }}</span>
                                <span class="ml-2 inline-block" v-if="sortBy === fields[index]">
                                    <AscendingIcon v-if="sortOrder === 1" />
                                    <DescendingIcon v-if="sortOrder === -1" />
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b" v-for="(item, index) in items" :key="item._id">
                            <td class="px-6 py-4" v-for="field in fields" :key="field">
                                <span v-if="field === 'icPhoto'" class="cursor-pointer" @click="selectImage(item[field])">
                                    <img :src="item[field]" class="h-20 object-cover" />
                                </span>
                                <span v-else-if="field === 'status'" class="cursor-pointer" @click="selectUserForStatus(item._id, item.status)">
                                    <span v-if="item[field] === 'suspended'"
                                        class="bg-red-100 text-red-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-red-900 dark:text-red-300">Suspended</span>
                                    <span v-if="item[field] === 'failed'"
                                        class="bg-red-100 text-red-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-red-900 dark:text-red-300">Failed</span>
                                    <span v-else-if="item[field] === 'available'"
                                        class="bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">Available</span>
                                    <span v-else-if="item[field] === 'pending'"
                                        class="bg-yellow-100 text-yellow-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300">Pending</span>
                                </span>
                                <span v-else-if="field === 'createdAt'">{{ formatDatetime(item[field]) }}</span>
                                <span v-else-if="field === 'exhibitors' || field === 'visitors'" class="cursor-pointer" @click="selectUserForEvent(index, field === 'exhibitors' ? 'exhibitor' : 'visitor')">
                                    {{ item[field] ? item[field].length : 0 }}
                                </span>
                                <span v-else>{{ item[field] }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ImageModal v-if="selectedImage.length > 0" :image="selectedImage" :close="closeImage" />
        <StatusModal v-if="selectedUser !== null && selectedStatus !== null" :userId="selectedUser" :status="selectedStatus" :close="closeStatus" />
        <EventModal v-if="selectedUserIndex !== -1 && selectedRole !== null" :userId="items[selectedUserIndex]._id" :role="selectedRole" :events="events" :userEvents="items[selectedUserIndex][`${selectedRole}s`]" :close="closeEvent" />
    </div>
</template>
<script>
import ImageModal from './ImageModal.vue';
import StatusModal from './StatusModal.vue';
import EventModal from './EventModal.vue';
export default {
    components: {
        ImageModal,
        StatusModal,
        EventModal,
    },

    data() {
        return {
            headers: ['Email', 'IC Number', 'IC Photo', 'Name', 'Status', 'Created At', 'Exhibitors', 'Visitors'],
            fields: ['email', 'icNumber', 'icPhoto', 'name', 'status', 'createdAt', 'exhibitors', 'visitors'],
            sortable: [true, true, false, true, true, true, false, false],
            items: [],

            // Filters
            search: '',
            email: '',
            icNumber: '',
            name: '',
            status: 'all',
            sortBy: 'createdAt',
            sortOrder: 1,

            events: {},
            selectedEvent: 'all',
            selectedEventRole: 'exhibitor',

            // Modals
            selectedImage: '',
            selectedUser: null,
            selectedStatus: null,
            selectedUserIndex: -1,
            selectedRole: null,
        };
    },

    async mounted() {
        await this.retrieveData();
        await this.retrieveEvents();
    },

    methods: {
        async retrieveData() {
            const response = await this.httpRequest('/organizer/user', 'get', {
                params: {
                    // email: this.email,
                    // icNumber: this.icNumber,
                    // name: this.name,
                    search: this.search,
                    status: this.status !== 'all' ? this.status : undefined,
                    sortBy: this.sortBy,
                    sortOrder: this.sortOrder,
                    eventId: this.selectedEvent !== 'all' ? this.selectedEvent : undefined,
                    eventTarget: this.selectedEventRole,
                }
            });
            if (response.result === 'success') {
                const items = response.data.users;
                this.items = JSON.parse(JSON.stringify(items).replace(/__host__/g, process.env.VUE_APP_API_URL));
            }
        },

        async retrieveEvents() {
            const response = await this.httpRequest('/organizer/user/events', 'get');
            if (response.result === 'success') {
                const events = {};
                for (const event of response.data.events) {
                    events[event._id] = event.title;
                }
                this.events = events;
            }
        },

        filterItem() {
            this.retrieveData();
        },

        sortItem(sortBy) {
            if (this.sortBy === sortBy) {
                this.sortOrder = this.sortOrder === -1 ? 1 : -1;
            } else {
                this.sortOrder = 1;
            }
            this.sortBy = sortBy;

            this.retrieveData();
        },

        async changeUserStatus(index, status) {
            const id = this.users[index]._id;
            const response = await this.httpRequest(`/user/${id}/status`, 'put', {
                data: {
                    status
                }
            });
            if (response.result === 'success') {
                this.retrieveData();
            }
        },

        selectImage(image) {
            this.selectedImage = image;
        },

        closeImage() {
            this.selectedImage = '';
        },

        selectUserForStatus(userId, status) {
            this.selectedUser = userId;
            this.selectedStatus = status;
        },

        closeStatus(reloadData = false) {
            this.selectedUser = null;
            this.selectedStatus = null;
            if (reloadData) {
                this.retrieveData();
            }
        },

        selectUserForEvent(index, role) {
            this.selectedUserIndex = index;
            this.selectedRole = role;
        },

        closeEvent(reloadData = false) {
            this.selectedUserIndex = -1;
            this.selectedRole = null;
            if (reloadData) {
                this.retrieveData();
            }
        }
    },

    computed: {
        numOfRecords() {
            return this.items.length;
        },
    },
}
</script>